import React from 'react';
import PropTypes from 'prop-types';
import PromotionModal from './PromotionModal';
import PromotionModalBehindExperiment from './PromotionModalBehindExperiment';

const PromotionModalFactory = props => {
  const { experiment } = props;
  const shouldUseExperiment = experiment && experiment.enabled;
  if (shouldUseExperiment) {
    return <PromotionModalBehindExperiment {...props} />;
  }

  return <PromotionModal {...props} />;
};

PromotionModalFactory.propTypes = {
  experiment: PropTypes.shape({})
};

export default PromotionModalFactory;
